<template>
  <div class="item-report">
    <div>
      <ai-breadcrumb />
      <div class="new-button">
        <guide class="guide-button" />
      </div>
    </div>
    <div v-loading="queryLoading" class="search-content">
      <el-form
        class="search-form"
        :inline="true"
        size="small"
        @submit.native.prevent
      >
        <el-form-item
          class="search-form-gutter"
          :label="$t('analysis.platform')"
        >
          <el-select
            style="width: 88px"
            v-model="listQuery.platform"
            @change="changePlatform"
            filterable
          >
            <el-option
              v-for="item in platformList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('analysis.date')">
          <el-select style="width: 118px" v-model="currentDate" filterable>
            <el-option
              v-for="item in dateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('report.target')">
          <el-radio-group
            v-model="listQuery.targetType"
            @change="changeTarget"
            class="addition-vs"
          >
            <el-radio-button
              v-for="item in targetTypeList"
              :key="item.key"
              :label="item.key"
              >{{ item.value }}</el-radio-button
            >
          </el-radio-group>
          <el-select style="width: 149px" v-model="listQuery.target" filterable>
            <el-option
              v-for="item in targetList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
          <label class="date-vs">VS</label>
          <el-select
            style="width: 149px"
            v-model="listQuery.compareTarget"
            filterable
          >
            <el-option
              v-for="item in targetList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('report.product')">
          <el-select
            style="width: 105px"
            :placeholder="$t('common.all')"
            v-model="listQuery.product"
            @change="changeProduct"
            filterable
          >
            <el-option
              v-for="item in productList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('report.season')">
          <el-select
            style="width: 135px"
            :placeholder="$t('common.all')"
            v-model="listQuery.season"
            clearable
            filterable
          >
            <el-option
              v-for="item in seasonList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter">
          <el-button
            :disabled="
              !currentDate || !listQuery.target || !listQuery.compareTarget
            "
            size="small"
            :circle="true"
            type="primary"
            @click="fetchData"
            icon="el-icon-search"
          ></el-button>
        </el-form-item>
        <el-form-item class="search-form-gutter">
          <el-button
            :disabled="
              !currentDate || !listQuery.target || !listQuery.compareTarget
            "
            class="excel-dl-btn"
            size="small"
            :circle="true"
            @click="handleDownload"
            icon="el-icon-download"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="chartLoading" class="data-content">
      <div v-if="noData" style="margin-top: 10px; padding: 20px">No Data</div>
      <div :class="{ hidden: noData }">
        <el-row>
          <el-col :span="12">
            <div id="left-chart-sales-style" />
          </el-col>
          <el-col :span="12">
            <div id="right-chart-sales-style" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { downloadFileAuth, serialize } from "@/utils/download-file";
import { aiApiRoot } from "@/utils/server";
import { getToken } from "@/utils/auth";
import {
  fetchUserBrandType,
  fetchUserBrands,
  fetchRecords,
} from "@/api/analysis";
import { fetchItemReportData } from "@/api/report";
import AiBreadcrumb from "@/components/AiBreadcrumb";
import Guide from "@/components/Guide";
export default {
  components: {
    AiBreadcrumb,
    Guide,
  },
  data() {
    return {
      currentDate: "",
      platformList: [
        { key: "tmall", value: "TMall" },
        { key: "tiktok", value: "Tiktok" },
      ],
      targetTypeList: [
        { key: "group", value: this.$t("report.group") },
        { key: "brand", value: this.$t("common.brand") },
      ],
      targetList: [],
      dateList: [],
      seasonList: [
        { key: "当年", value: this.$t("report.currentYear") },
        { key: "往年", value: this.$t("report.previousYear") },
      ],
      productList: [
        { key: "fashion", value: this.$t("report.fashion") },
        { key: "etc", value: this.$t("report.etc") },
      ],
      itemList: [],
      listQuery: {
        platform: "tmall",
        targetType: "group",
        target: "",
        compareTarget: "",
        date: "",
        season: "",
        product: "fashion",
      },
      graphData: {
        first: {},
        second: {},
        items: [],
      },
      leftSalesStyleChart: null,
      rightSalesStyleChart: null,
      chartLoading: false,
      queryLoading: false,
      hasFirstLoad: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.leftSalesStyleChart = echarts.init(
      document.getElementById("left-chart-sales-style")
    );
    this.rightSalesStyleChart = echarts.init(
      document.getElementById("right-chart-sales-style")
    );

    this.fetchDates();
  },
  beforeUnmout() {
    window.removeEventListener("resize", this.handleResize);
    this.leftSalesStyleChart.dispose();
    this.rightSalesStyleChart.dispose();
  },
  methods: {
    initGraphData() {
      this.graphData = {
        first: {},
        second: {},
      };
    },
    handleResize() {
      if (this.leftSalesStyleChart) {
        this.leftSalesStyleChart.resize();
      }
      if (this.rightSalesStyleChart) {
        this.rightSalesStyleChart.resize();
      }
    },
    fetchDates() {
      this.queryLoading = true;
      this.dateList = [];
      this.currentDate = "";
      fetchRecords({
        type: "sales",
        period: "week",
        platform: this.listQuery.platform,
        limit: -1,
      })
        .then((response) => {
          if (response.success) {
            response.result &&
              response.result.items &&
              response.result.items.forEach((e) => {
                this.dateList.push({
                  value: e.date,
                  label: e.linkDate,
                });
              });
            if (this.dateList && this.dateList.length > 0) {
              this.currentDate = this.dateList[0].value;
            }
          }
          this.queryLoading = false;
        })
        .catch(() => {
          this.queryLoading = false;
        });
    },
    fetchTargets() {
      this.queryLoading = true;
      this.targetList = [];
      this.listQuery.target = "";
      this.listQuery.compareTarget = "";
      if (this.listQuery.targetType === "group") {
        fetchUserBrandType()
          .then((response) => {
            if (response.success) {
              this.targetList = response.result.items
                ? response.result.items.map((t) => {
                    return { key: t, value: t };
                  })
                : [];
              if (this.targetList && this.targetList.length > 0) {
                this.listQuery.target = this.targetList[0].key;
                if (this.targetList.length > 1) {
                  this.listQuery.compareTarget = this.targetList[1].key;
                } else {
                  this.listQuery.compareTarget = this.targetList[0].key;
                }
                this.fetchData(true);
              }
            }
            this.queryLoading = false;
          })
          .catch(() => {
            this.queryLoading = false;
          });
      } else {
        fetchUserBrands({
          platform: this.listQuery.platform,
          dates: this.currentDate,
        })
          .then((response) => {
            if (response.success) {
              this.targetList = response.result.items
                ? response.result.items.map((t) => {
                    return { key: t.id + "", value: t.name };
                  })
                : [];
              if (this.targetList && this.targetList.length > 0) {
                this.listQuery.target = this.targetList[0].key;
                if (this.targetList.length > 1) {
                  this.listQuery.compareTarget = this.targetList[1].key;
                } else {
                  this.listQuery.compareTarget = this.targetList[0].key;
                }
              }
            }
            this.queryLoading = false;
          })
          .catch(() => {
            this.queryLoading = false;
          });
      }
    },
    fetchData(firstLoad) {
      if (
        !this.currentDate ||
        !this.listQuery.target ||
        !this.listQuery.compareTarget
      ) {
        return;
      }
      this.listQuery.date = this.currentDate;
      if (firstLoad === true) {
        if (this.hasFirstLoad) {
          return;
        }
        this.hasFirstLoad = true;
      }
      this.chartLoading = true;
      this.initGraphData();
      fetchItemReportData(this.listQuery)
        .then((response) => {
          if (response.success) {
            this.graphData = response.result;
            if (
              this.graphData &&
              this.graphData.first["items"] &&
              this.graphData.second["items"]
            ) {
              this.$nextTick(() => {
                this.drawSalesStyleChart();
              });
            }
          }
          this.chartLoading = false;
        })
        .catch(() => {
          this.chartLoading = false;
        });
    },
    drawSalesStyleChart() {
      let generateChart = (chart, data) => {
        let option = {
          title: {
            text: this.$t("common.item"),
            padding: [5, 10],
            textStyle: {
              fontSize: 16,
            },
          },
          grid: {
            top: 40,
            left: 30,
            bottom: 10,
            right: 20,
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            valueFormatter: (value) => value + "%",
          },
          legend: {
            data: [this.$t("report.sales"), this.$t("report.style")],
          },
          xAxis: {
            type: "category",
            data: data["items"],
            axisTick: {
              interval: 0,
            },
            axisLabel: {
              interval: 0,
              rotate: 45,
            },
          },
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: "{value} %",
              },
              max: max,
            },
          ],
          series: [
            {
              name: this.$t("report.sales"),
              type: "bar",
              data: data["salesPercentage"],
            },
            {
              name: this.$t("report.style"),
              type: "bar",
              data: data["stylePercentage"],
            },
          ],
        };
        chart.setOption(option, true);
      };
      let max = 0;
      let maxValue = (a) => {
        if (a && a.length > 0) {
          a.forEach((e) => {
            if (max < e) {
              max = e;
            }
          });
        }
      };
      maxValue(this.graphData.first["salesPercentage"]);
      maxValue(this.graphData.first["stylePercentage"]);
      maxValue(this.graphData.second["salesPercentage"]);
      maxValue(this.graphData.second["stylePercentage"]);
      generateChart(this.leftSalesStyleChart, this.graphData.first, max);
      generateChart(this.rightSalesStyleChart, this.graphData.second, max);
    },
    handleDownload() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.preparingData"),
      });
      let query = this.listQuery;
      query.date = this.currentDate;
      downloadFileAuth(
        aiApiRoot + "/v1/report/item/export?" + serialize(query),
        query.date + "_item_report_" + Date.now() + ".xlsx",
        getToken(),
        () => {
          loading.close();
        }
      );
    },
    changePlatform() {
      this.fetchDates();
    },
    changeProduct() {},
    changeTarget() {
      this.fetchTargets();
    },
  },
  computed: {
    noData() {
      return (
        !this.graphData ||
        !this.graphData.first["items"] ||
        !this.graphData.second["items"]
      );
    },
  },
  watch: {
    currentDate() {
      this.fetchTargets();
    },
  },
};
</script>

<style lang="scss" scoped>
.item-report {
  .new-button {
    text-align: right;
    width: 100%;
    margin: 10px 0;
  }
  .search-content {
    background-color: #fff;
    padding: 10px 0 0 10px;
    margin-bottom: 10px;

    .el-form-item {
      margin-bottom: 10px;
    }

    .search-form {
      width: auto;

      .search-form-gutter {
        margin-right: 10px;
      }
    }

    .addition-vs {
      vertical-align: inherit;
      margin-right: 12px;
    }

    .date-vs {
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      margin-left: 12px;
      margin-right: 12px;
    }
  }

  .data-content {
    background-color: #fff;
    min-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #606266;

    ::v-deep .el-row {
      padding-top: 10px;
    }

    .hidden {
      visibility: hidden;
      height: 0px;
      div {
        overflow: hidden;
      }
    }
  }

  .item-content {
    margin-top: 10px;
    padding: 10px 0 0 10px;
    background-color: #fff;
  }

  .item-content.hidden {
    visibility: hidden;
    height: 0px;
    div {
      overflow: hidden;
    }
  }

  #left-chart-sales-style {
    width: 100%;
    min-height: 248px;
    height: calc(100vh - 100px - 52.5px - 96px - 10.5px - 10px - 10px);
  }

  #right-chart-sales-style {
    width: 100%;
    min-height: 248px;
    height: calc(100vh - 100px - 52.5px - 96px - 10.5px - 10px - 10px);
  }
}
</style>